<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Audit Opinions</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAuditOpinionCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAuditOpinion()">
        <mat-icon>add</mat-icon>
        Add Audit Opinion
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditOpinions()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditOpinion($event)"
      (deleteClick)="onDeleteAuditOpinion($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
